import styled from 'styled-components';

export const StyledSaleEventEndCardContainer = styled.div`
  height: 100%;
  width: 100%;
  border-right: 6px solid blue;
  border-radius: 0 3px 3px 0;
  background-color: ${({ theme }) => theme.COLORS.BASE};
`;

export const StyledSaleEventEndCard = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 18px 12px;
  border-top: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
  border-bottom: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
`;

export const StyledHeader = styled.div`
  text-align: right;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
`;

export const StyledJumpToStart = styled.a`
  position: absolute;
  bottom: 0;
  right: 0;
  padding-bottom: 12px;
  padding-right: 12px;
  cursor: pointer;
  text-decoration-line: underline;
`;
